import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIkeaComponent } from './simple-icons-ikea.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIkeaComponent ],
    exports:      [ SimpleIconsIkeaComponent ],
    bootstrap:    []
})
export class SimpleIconsIkeaModule {}
